export default {"src":"/_next/static/media/icon_footer_play_tungsten.35dbc6c1.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};